{
  "translation": {
    "aboutMirador": "关于Mirador项目",
    "aboutThisItem": "有关此条目",
    "addedFromUrl": "(从URL添加)",
    "addManifestUrl": "来源",
    "addManifestUrlHelp": "IIIF资源的URL",
    "addResource": "添加资源",
    "annotationCanvasLabel_1/1": "条目: [{{label}}]",
    "annotationCanvasLabel_1/2": "左方: [{{label}}]",
    "annotationCanvasLabel_2/2": "右方: [{{label}}]",
    "annotations": "标注",
    "attribution": "著作权",
    "attributionTitle": "著作权",
    "authenticationFailed": "认证失败。",
    "authenticationRequired": "完全访问需要认证",
    "backToResults": "返回到结果",
    "book": "书籍",
    "bottom": "下方",
    "cancel": "取消",
    "canvasIndex": "索引",
    "changeTheme": "变更背景主题",
    "clearSearch": "清除",
    "close": "关闭",
    "closeAddResourceForm": "关闭表格",
    "closeAddResourceMenu": "关闭资源列表",
    "closeCompanionWindow": "关闭附属窗口",
    "closeWindow": "关闭窗口",
    "collapseSection": "关闭{{section}}分页",
    "collapseSidePanel": "关闭边栏",
    "collection": "集合",
    "continue": "继续",
    "copy": "复制",
    "currentItem": "当前条目",
    "currentItem_1/1": "当前条目",
    "currentItem_1/2": "左方",
    "currentItem_2/2": "右方",
    "dark": "暗色主题",
    "digitizedView": "数字视图",
    "dismiss": "关闭信息",
    "displayNoAnnotations": "不高亮",
    "downloadExport": "导出桌面排版",
    "downloadExportWorkspace": "导出桌面排版",
    "elastic": "弹性",
    "elasticDescription": "在桌面上自由摆放窗口",
    "emptyResourceList": "空资源列表",
    "error": "错误",
    "errorDialogConfirm": "确定",
    "errorDialogTitle": "发生错误",
    "exitFullScreen": "退出全屏",
    "expandSection": "开启{{section}}分页",
    "expandSidePanel": "开启边栏",
    "exportCopied": "工作区配置被复制到你的剪贴板上了",
    "fetchManifest": "添加",
    "fullScreen": "全屏",
    "gallery": "画廊",
    "hideZoomControls": "隐藏缩放选项",
    "highlightAllAnnotations": "高亮所有标注",
    "iiif_homepage": "主页",
    "iiif_manifest": "IIIF清单",
    "iiif_renderings": "其他格式",
    "iiif_seeAlso": "另见",
    "import": "导入",
    "importWorkspace": "导入桌面排版",
    "importWorkspaceHint": "在此贴上Mirador 4排版设定码",
    "item": "条目: {{label}}",
    "itemList": "标题列表",
    "jsError": "技术细节",
    "jsStack": "{{ stack }}",
    "language": "语言",
    "layer_hide": "隐藏图层",
    "layer_move": "移动图层",
    "layer_opacity": "图层不透明度",
    "layer_show": "显示图层",
    "layers": "图层",
    "light": "亮色主题",
    "links": "链接",
    "listAllOpenWindows": "切换至窗口",
    "login": "登入",
    "logout": "登出",
    "manifestError": "无法增添资源:",
    "maximizeWindow": "窗口最大化",
    "minimizeWindow": "窗口最小化",
    "mirador": "Mirador",
    "miradorResources": "Mirador资源",
    "miradorViewer": "Mirador阅览器",
    "more": "更多...",
    "moreResults": "更多结果",
    "mosaic": "马赛克",
    "mosaicDescription": "在桌面上以格状方式排列窗口",
    "moveCompanionWindowToBottom": "移至下方",
    "moveCompanionWindowToRight": "移至右方",
    "multipartCollection": "多卷集合",
    "nextCanvas": "下一页",
    "noItemSelected": "没有条目被选中",
    "numItems_one": "{{number}} 项条目",
    "numItems_other": "{{number}} 项条目",
    "off": "关闭",
    "openCompanionWindow_annotations": "标注",
    "openCompanionWindow_attribution": "著作权",
    "openCompanionWindow_canvas": "目录",
    "openCompanionWindow_info": "资讯",
    "openCompanionWindow_layers": "图层",
    "openCompanionWindow_search": "搜索",
    "openInCompanionWindow": "移至新附属窗口",
    "openWindows": "当前窗口",
    "pagination": "{{current}} / {{total}}",
    "position": "位置",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "上一页",
    "related": "相关信息",
    "resource": "资源",
    "retry": "重试",
    "right": "右方",
    "rights": "版权",
    "scroll": "滚动",
    "searchInputLabel": "搜索关键字",
    "searchNextResult": "下一个结果",
    "searchNoResults": "没有搜索到结果",
    "searchPreviousResult": "前一个结果",
    "searchResultsRemaining": "{{numLeft}}剩余",
    "searchSubmitAria": "提交搜索",
    "searchTitle": "搜索",
    "selectWorkspaceMenu": "选择桌面排版方式",
    "showCollection": "显示集合",
    "showingNumAnnotations_one": "显示 {{number}} 项标注",
    "showingNumAnnotations_other": "显示 {{number}} 项标注",
    "showZoomControls": "显示缩放选项",
    "sidebarPanelsNavigation": "切换边栏",
    "single": "单项",
    "startHere": "按此开始",
    "suggestSearch": "搜索本文档以\"{{ query }}\"",
    "tableOfContentsList": "目录",
    "theme": "背景主题",
    "thumbnailList": "缩略图列表",
    "thumbnailNavigation": "缩略图",
    "thumbnails": "缩略图",
    "toggleWindowSideBar": "切换边栏开关",
    "totalCollections_one": "{{count}} 集合",
    "totalCollections_other": "{{count}} 集合",
    "totalManifests_one": "{{count}} 清单",
    "totalManifests_other": "{{count}} 清单",
    "tryAgain": "请重试",
    "untitled": "[无标题]",
    "view": "条目排列方式",
    "viewWorkspaceConfiguration": "查看工作区配置",
    "welcome": "欢迎使用Mirador",
    "window": "窗口: {{label}}",
    "windowMenu": "窗口视图 & 缩略图显示",
    "windowNavigation": "切换窗口",
    "windowPluginButtons": "选项",
    "windowPluginMenu": "窗口选项",
    "workspace": "桌面",
    "workspaceFullScreen": "全屏",
    "workspaceMenu": "桌面设定",
    "workspaceNavigation": "工作区导航",
    "workspaceOptions": "桌面选项",
    "workspaceSelectionTitle": "选择桌面排版方式",
    "zoomIn": "放大",
    "zoomOut": "缩小",
    "zoomReset": "重设缩放"
  }
}
